/**
 * Static thumbnail — first frame only, no autoplay. Use on cards/tiles so the
 * listing doesn't become a wall of playing videos on mobile data.
 *
 * Extracted from `app/(main)/products/ProductsClient.tsx` lines 124–156.
 */

"use client";

import type React from "react";
import { Play } from "lucide-react";
import { useVideoBlobFallback } from "@/hooks/useVideoBlobFallback";

export function StaticVideoThumbnail({
  src,
  className,
  onLoadedMetadata,
  "aria-label": ariaLabel,
  ...rest
}: React.ComponentProps<"video">) {
  const { activeSrc, error, handleError } = useVideoBlobFallback(
    src as string | undefined
  );

  if (error) {
    return (
      <div
        className={`flex items-center justify-center bg-muted text-muted-foreground ${className ?? ""}`}
      >
        <Play className="h-6 w-6 opacity-50" />
      </div>
    );
  }

  return (
    <video
      key={activeSrc}
      src={activeSrc}
      className={className}
      muted
      playsInline
      preload="metadata"
      onLoadedMetadata={onLoadedMetadata}
      onError={handleError}
      aria-label={ariaLabel}
      {...rest}
    />
  );
}
